/**
 * Company: SPHMedia
 * Description: Lifestyle Section Layout
 */

import { Await } from "react-router";
import { LifestyleContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import LifestylePageContent from "@pages/Section/layouts/Lifestyle/LifestylePageContent";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";
/**
 * Lifestyle
 * Description: Lifestyle Section Layout
 * @param {SectionProps} props
 * @returns {SectionContext}
 */
export type SectionProps = {
  context: LifestyleContext;
};

export default function LifestylePage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<LifestyleContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind === "section") {
          return <LifestylePageContent data={data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
